<template>
  <div>
    <b-input-group class="autocomplete-input-group">
      <b-form-input
        id="input-town"
        size="sm"
        :disabled="isDisabled"
        v-model="query"
        :placeholder="items.length === 0 ? 'Создайте город' : 'Выберите город'"
        :state="state"
        autocomplete="off"
        class="autocomplete-input-group"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="!query || isDisabled" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
        <b-button
          v-if="canCreateCatalog()"
          size="sm"
          variant="success"
          :disabled="isDisabled"
          @click="showModalCatalog"
          v-b-tooltip.hover.v-success
          title="Создать город"
        >
          <font-awesome-icon icon="plus"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-town" v-if="isFocus">
        <b-list-group-item
          v-for="(item, index) in filteredItems"
          :key="index"
          @mousedown="onClick(item)"
          button
        >
          {{ getItemListText(item) }}
        </b-list-group-item>
        <b-list-group-item v-if="items.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>

    <town-catalog
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onTownCreated"
    />

  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import TownCatalog from "./TownCatalog.vue";

export default {
  name: "TownSelect",
  components: { TownCatalog },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean },
    id: { type: Number },
    state: { type: Boolean, default: null }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      town: null,
      isModalVisible: false
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();
      const currentItem = this.items.find(item => item.id === this.id);

      if (currentItem && currentItem.name.toLowerCase() === lowerQuery) return this.items;

      return this.items.filter(item => item.name.toLowerCase().includes(lowerQuery));
    }
  },
  methods: {
    async configure(id) {
      if (id > 0) {
        const result = await this.getTownById(id);

        if (result && result.data) {
          this.query = result.data.name;
          this.town = result.data;
        }
      } else {
        this.query = "";
      }
    },
    async onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.town) {
        if (this.query !== this.town.name) {
          this.query = this.town.name;
        }
      } else {
        this.query = "";
      }
    },
    onClear() {
      this.query = "";
      this.town = null;
      this.$emit('onSelect',null);
    },
    onClick(item) {
      this.query = item.name;
      this.town = item;
      this.$emit('onSelect', item);
    },
    getItemListText(item) {
      return item.name;
    },
    async getItems() {
      const result = await this.getTowns({ perPage: 500 });
      this.items = (result && result.data) ? result.data.items : [];
    },
    showModalCatalog() {
      this.isModalVisible = true;
    },
    async onTownCreated(newItem) {
      this.items.push(newItem);
      this.onClick(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canCreateCatalog() {
      return this.hasPermission([PERM.CATALOG_TOWN_EDIT]);
    }
  },
  watch: {
    'id': {
      handler(newId) {
          this.configure(newId);
      }, immediate: true
    },
  }
}
</script>

<style scoped>
/* Autocomplete Select Input */
.autocomplete-town {
  margin-top: 31px;
  max-height: 250px;
  overflow-y: auto;
  position: absolute;
  z-index: 1030;
  text-align: left;
}

.autocomplete-input-group {
  position: unset;
}

/* Autocomplete Select Input Group Item */
.autocomplete-town .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Towns/TownSelect.vue